module.exports = __webpack_public_path__ + "static/media/laborest-tiobec_800.97e04058.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/laborest-tiobec_800.png
// module id = 799
// module chunks = 0